<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'callConfigEdit',
      key: 'id',
      url: {
        get: "/admin/system/callConfig",
      },
      items: [
        {
          label: "坐席通道",
          name: "seatId",
          value: "",
          type: "input",
          width: "400px",
          disabled: "true",
        },
        {
          label: "自定义名称",
          name: "channelName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
      ],
      forms: {},
    };
  },
  created() {

  },
  mounted() {


  },
  methods: {

    handleSubmit() {
      let q = this.forms
      this.$refs.form.validate(async (valid) => {
        let res = await $utils.api.load(`/admin/system/callConfig/edit`, q, "POST")
        try {
          if (res.status) {
            $utils.toast.success("保存成功");
            $utils.url.go(-1);
          }
        } catch (e) {
          $utils.toast.error("保存异常" + e.message);
        }
      });
    },


  },
};
</script>

<style lang="less">
</style>
